export const colors = {
    brand: {
        50: "#E9F3FD",
        100: "#C7E0F9",
        200: "#92BFF4",
        300: "#5991E0",
        400: "#3067C2",
        500: "#00359A",
        600: "#002884",
        700: "#001E6E",
        800: "#001559",
        900: "#000F49",
    },
    accent:{
        50: "#FEF6CB",
        100: "#FEF6CB",
        200: "#FDEB97",
        300: "#F9DB63",
        400: "#F3C93C",
        500: "#EBB000",
        600: "#CA9200",
        700: "#A97500",
        800: "#885B00",
        900: "#704800",
    },
    green:{
        50: "#EEFBCE",
        100: "#EEFBCE",
        200: "#D9F89F",
        300: "#B8EA6C",
        400: "#96D645",
        500: "#68BC13",
        600: "#50A10D",
        700: "#3C8709",
        800: "#2A6D06",
        900: "#1D5A03",
    },
    sidebar: '#122960',
    
    flat:{            
        tomato: "#FB4630",
        pink: "#FE445F",
        purple: "#773DE3",
        indigo: "#B28FF0",
        navy: "#3C50BC",
        blue: "#3389E1",
        aqua: "#00C3ED",
        teal: "#009988",
        green: "#77C33E",
        lime: "#A8E172",
        yellow: "#FFCC34",
        orange: "#FFB718",
        gray: "#616C78"
    },
    muted:{            
        tomato: "rgba(251,70,48, 0.25)",
        pink: "rgba(254,68,95, 0.25)",
        purple: "rgba(119,61,227, 0.25)",
        indigo: "rgba(178,141,240, 0.25)",
        navy: "rgba(60,80,188, 0.25)",
        blue: "rgba(51,137,225, 0.25)",
        aqua: "rgba(0,195,237, 0.25)",
        teal: "rgba(0,189,153, 0.25)",
        green: "rgba(119,195,62, 0.25)",
        lime: "rgba(168,225,114, 0.25)",
        yellow: "rgba(255,204,52, 0.25)",
        orange: "rgba(255,183,24, 0.25)",
        gray: "rgba(97,108,120, 0.25)",
    }      
}